export default {
    afterReturnAddress: 'After Return Address',
    shippingAddressAfter: 'After Shipping Address',
    selectCountry: 'Select Country',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    tips: 'Tips',
    deleteConfirm: 'Are you sure you want to delete this address?',
    county: 'County',
    subcountyTown: 'Subcounty/Town',
    areaWard: 'Area(ward)',
    detailAddress: 'Detail Address',
    name: 'Name',
    phone: 'Phone',
    isDefault: 'Is Default',
    yes: 'Yes',
    no: 'No',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    pleaseInputName: 'Please input name',
    pleaseInputPhone: 'Please input phone',
    pleaseInputDetail: 'Please input detail address',
    pickupPoint: 'Pickup Point',
    select: 'Select',
    pleaseSelectPickupPoint: 'Please select Pickup Point',
    close: 'Close',
    normal: 'Normal',
    frozen: 'Frozen',
    nonData: 'No Data',
    status: 'Status',
    name: 'Name',
    phone: 'Phone',
    location: 'Location',
    pleaseInputNames: 'Please input name',
    search: 'Search',
    repairEntrustTitle: 'Platform Authorized Repair Agency Service',
    repairEntrustDesc: 'Platform Paid Authorized Repair: Merchants may designate specific categories & brands for platform proxy maintenance. If you do not enable category/brand repair agency, or your products fail to match the supported categories or brands even after enabling this service, all after-sales repair work shall be handled by merchants independently.',
    repairEntrustCategoryTitle: 'Category-Based Platform Repair Agency',
    repairEntrustBrandTitle: 'Brand-Based Platform Repair Agency',
    repairEntrustCategoryDesc: 'Check this option. For products falling into platform-supported repair categories, maintenance will be undertaken by designated platform repair service providers. This is a value-added paid service.',
    repairEntrustBrandDesc: 'Check this option. For products belonging to platform-supported repair brands, maintenance will be undertaken by designated platform repair service providers. This is a value-added paid service.',
    viewFeeStandards: 'View Fee Standards',
    viewSupportedCategories: 'View Supported Repair Categories',
    viewSupportedBrands: 'View Supported Repair Brands',
}